import React from 'react';
import './BrandLogo.css';

/**
 * KnightSteps Brand Typography
 * Uses the exact system typeface, weights, and styling from the backend email template:
 * font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
 * font-weight: 800; letter-spacing: -0.3px;
 * "Knight" (#ffffff) + "Steps" (#818cf8)
 */

export const BrandText = ({ className = '', ...props }) => (
  <span className={`ks-brand-full ${className}`.trim()} {...props}>
    Knight<span className="ks-brand-text-accent">Steps</span>
  </span>
);

export const KSText = ({ className = '', ...props }) => (
  <span className={`ks-brand-full ${className}`.trim()} {...props}>
    K<span className="ks-brand-text-accent">S</span>
  </span>
);

export default BrandText;
